import React, { Fragment, useEffect, useRef } from "react";
import $ from "jquery";
import "select2/dist/js/select2.min.js";
import { Tooltip } from "bootstrap";
const Select2Component = ({ attr, selectedValue, onChangeEvent, getConflictText = () => "" }) => {
  const selectRef = useRef(null);
  const changeHandlerRef = useRef(onChangeEvent);
  const tooltipsRef = useRef([]);

  useEffect(() => {
    changeHandlerRef.current = onChangeEvent;
  });

  useEffect(() => {
    const $select = $(selectRef.current);
    const $ancestors = $select.parents();
    $select.select2({
      minimumResultsForSearch: Infinity, // Disables search box
      templateResult: (data) => {
        if (!data.element || !data.element.dataset || !data.element.dataset.conflict) return data.text;
        var c = data.element.dataset.attrname;
        return $('<span class="select2-option-unavailable"></span>')
          .text(data.text)
          .append($('<small class="select2-option-unavailable-note"></small>').text(`${c} is not available`));
      },
    });

    const disposeTooltips = () => {
      tooltipsRef.current.forEach((instance) => {
        try {
          instance.dispose();
        } catch (e) {
          console.error(e);
        }
      });
      tooltipsRef.current = [];
    };

    const buildTooltips = () => {
      disposeTooltips();
      $(".select2-container--open .select2-results__option").each((index, element) => {
        const message = element.getAttribute("title") || element.getAttribute("data-bs-original-title");
        if (!message) return;
        tooltipsRef.current.push(
          new Tooltip(element, {
            title: message,
            placement: "right",
            fallbackPlacements: ["left", "top", "bottom"],
            trigger: "hover focus",
            container: "body",
            customClass: "select2-conflict-tooltip",
          })
        );
      });
    };

    if (selectedValue) {
      $select.val(selectedValue);
    }
    $select.on("change", (e) => {
      const value = $(e.target).val();
      if (typeof changeHandlerRef.current === "function") changeHandlerRef.current(attr.attrName, value);
    });
    $select.on("select2:open", () => {
      window.setTimeout(buildTooltips, 0);
    });
    $select.on("select2:close", disposeTooltips);

    return () => {
      disposeTooltips();
      $select.off("change select2:open select2:close");
      if ($select.data("select2")) {
        if ($select.data("select2").isOpen()) $select.select2("close");
        $select.select2("destroy");
      }
      $ancestors.off("scroll.select2");
    };
  }, [attr]);

  useEffect(() => {
    const $select = $(selectRef.current);
    if (!selectedValue || !$select.data("select2") || $select.val() == selectedValue) return;
    $select.val(selectedValue).trigger("change.select2");
  }, [selectedValue]);

  return (
    <Fragment>
      {attr && (
        <div className="proSelect-color proSelect-length">
          <label>Select {attr.attrName}</label>
          <select ref={selectRef} className="js-states form-control">
            {attr.attrData &&
              attr.attrData.map((item, index) => {
                const conflict = getConflictText(attr.attrName, item.filterString);
                return (
                  <option
                    key={index}
                    selected={item.selected == 1 ? "selected" : ""}
                    data-conflict={conflict ? "true" : undefined}
                    data-attrname={attr.attrName}
                    title={conflict}
                    value={item.filterString}
                  >
                    {item.filterString}
                  </option>
                );
              })}
          </select>
        </div>
      )}
    </Fragment>
  );
};

export default Select2Component;
